import { style } from 'typestyle';
import { primaryTextColor } from 'src/utils/Style/Theme';

export const ACCORDION_HEADER_HEIGHT = 35;
export const KEY_FINANCIAL_EXPANDED_HEIGHT = 135;
export const CHOICE_PRODUCTIVITY_EXPANDED_HEIGHT = 200;

export const categorySummaryContainer = style({
  $debugName: 'categorySummaryStyle',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  $nest: {
    '.category-summary-container': {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
    },
    '.choice-productivity-container': {
      display: 'flex',
      $nest: {
        '&.print': {
          height: 'auto',
        },
        '.fin-wrapper': {
          display: 'flex',
          width: '20%',
          alignItems: 'center',
          minWidth: 220,
          // override key financial item styles when rendered in choice productivity
          $nest: {
            '.key-financial-item': {
              backgroundColor: 'white',
            },
            header: {
              fontWeight: 300,
            },
            '.primary': {
              color: primaryTextColor,
              flex: 'none',
              marginRight: '1rem',
            },
          },
        },
        '.choice-wrapper': {
          flex: 1,
          display: 'flex',
          flexWrap: 'wrap',
          overflow: 'auto',
        },
      },
    },
    '.grid-container': {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      $nest: {
        '&.print': {
          height: 'unset',
          overflowX: 'auto',
        },
        '.data-grid': {
          flex: '1',
          fontSize: '0.8rem',
        },
      },
    },
  },
});
